import api from '@/utils/api';
import {
    FETCH_LABO_CASES,
    FETCH_LABO_CASE_DETAIL,
    CREATE_LABO_CASE,
    UPDATE_LABO_CASE,
    DELETE_LABO_CASES,
    FETCH_LABO_CASE_STATUS_STATISTICS,
    FETCH_LABO_CASE_CUSTOMER_STATISTICS
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Lấy danh sách bản ghi với điều kiện lọc và phân trang.
 * @param {Object} filters Các bộ lọc: { keyword, status, page, per_page }
 */
export const fetchLaboCaseList = (filters) => dispatch => {
    return api.get('/labo-cases', { params: filters }).then(res => {
        dispatch({ type: FETCH_LABO_CASES, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể tải danh sách');
        throw err;
    });
};

/**
 * Lấy chi tiết một bản ghi theo ID.
 * @param {number} id
 */
export const fetchLaboCaseDetail = (id) => dispatch => {
    return api.get(`/labo-cases/${id}`).then(res => {
        dispatch({ type: FETCH_LABO_CASE_DETAIL, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể lấy chi tiết');
        throw err;
    });
};

/**
 * Tạo mới một bản ghi.
 * @param {Object} data Dữ liệu cần gửi lên server
 */
export const createLaboCase = (data) => dispatch => {
    return api.post('/labo-cases', data).then(res => {
        dispatch({ type: CREATE_LABO_CASE, payload: res.data.data });
        NotificationManager.success(res.data.msg || 'Tạo thành công');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Tạo thất bại');
        throw err;
    });
};

/**
 * Cập nhật một bản ghi theo ID.
 * @param {number} id
 * @param {Object} data Dữ liệu cập nhật
 */
export const updateLaboCase = (id, data) => dispatch => {
    return api.put(`/labo-cases/${id}`, data).then(res => {
        dispatch({ type: UPDATE_LABO_CASE, payload: res.data.data });
        NotificationManager.success(res.data.msg || 'Cập nhật thành công');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Cập nhật thất bại');
        throw err;
    });
};

/**
 * Xoá nhiều bản ghi theo danh sách ID.
 * @param {number[]} ids
 */
export const deleteLaboCases = (ids) => dispatch => {
    return api.delete('/labo-cases', { data: { ids } }).then(res => {
        dispatch({ type: DELETE_LABO_CASES, payload: ids });
        NotificationManager.success(res.data.msg || 'Xoá thành công');
        return res.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Xoá thất bại');
        throw err;
    });
};

/**
 * Lấy thống kê trạng thái các labo-case.
 * @param {Object} filters Các tham số lọc nếu có
 */
export const fetchStatusStatistics = (filters = {}) => dispatch => {
    return api.get('/labo-cases/status-statistics', { params: filters }).then(res => {
        dispatch({ type: FETCH_LABO_CASE_STATUS_STATISTICS, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể tải thống kê trạng thái');
        throw err;
    });
};

/**
 * Lấy thống kê trạng thái các labo-case.
 * @param {Object} filters Các tham số lọc nếu có
 */
export const fetchCustomerStatistics = (filters = {}) => dispatch => {
    return api.get('/labo-cases/customer-statistics', { params: filters }).then(res => {
        dispatch({ type: FETCH_LABO_CASE_CUSTOMER_STATISTICS, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể tải thống kê trạng thái');
        throw err;
    });
};

